var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#FFF8E1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2525_1916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 17C27.4288 17 24.9154 17.7624 22.7776 19.1909C20.6398 20.6194 18.9735 22.6497 17.9896 25.0251C17.0056 27.4006 16.7482 30.0144 17.2498 32.5362C17.7514 35.0579 18.9895 37.3743 20.8076 39.1924C22.6257 41.0105 24.9421 42.2486 27.4638 42.7502C29.9856 43.2518 32.5995 42.9944 34.9749 42.0104C37.3503 41.0265 39.3807 39.3603 40.8091 37.2224C42.2376 35.0846 43 32.5712 43 30C42.9963 26.5533 41.6254 23.2489 39.1883 20.8117C36.7511 18.3746 33.4467 17.0037 30 17ZM30 40.8333C27.8574 40.8333 25.7629 40.198 23.9813 39.0076C22.1998 37.8172 20.8113 36.1253 19.9913 34.1457C19.1714 32.1662 18.9568 29.988 19.3748 27.8865C19.7928 25.7851 20.8246 23.8547 22.3397 22.3397C23.8548 20.8246 25.7851 19.7928 27.8865 19.3748C29.988 18.9568 32.1662 19.1714 34.1457 19.9913C36.1253 20.8113 37.8172 22.1998 39.0076 23.9813C40.198 25.7629 40.8333 27.8574 40.8333 30C40.8302 32.8722 39.6878 35.6259 37.6568 37.6568C35.6259 39.6878 32.8722 40.8302 30 40.8333Z",
    fill: "#F0B72A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9998 22.4167C29.7125 22.4167 29.437 22.5309 29.2338 22.734C29.0306 22.9372 28.9165 23.2128 28.9165 23.5001V32.1667C28.9165 32.4541 29.0306 32.7296 29.2338 32.9328C29.437 33.1359 29.7125 33.2501 29.9998 33.2501C30.2872 33.2501 30.5627 33.1359 30.7659 32.9328C30.969 32.7296 31.0832 32.4541 31.0832 32.1667V23.5001C31.0832 23.2128 30.969 22.9372 30.7659 22.734C30.5627 22.5309 30.2872 22.4167 29.9998 22.4167Z",
    fill: "#F0B72A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0832 36.5001C31.0832 35.9018 30.5981 35.4167 29.9998 35.4167C29.4015 35.4167 28.9165 35.9018 28.9165 36.5001C28.9165 37.0984 29.4015 37.5834 29.9998 37.5834C30.5981 37.5834 31.0832 37.0984 31.0832 36.5001Z",
    fill: "#F0B72A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2525_1916"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(17 17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning_icon.006b9a10e1baa3f69993d383e0110af3.svg";
export { ForwardRef as ReactComponent };